import { baseClasses } from '@weatherbug/common';
import { SnowSkiProvider } from '../providers/snowSkiProvider';

const { AsyncAction } = baseClasses;

export const GET_SNOW_SKI = new AsyncAction('GET_SNOW_SKI');

export function getSnowSki(baseUrl, authId, secret, latitude, longitude, units, rangeKm, maxResults, refresh) {
    return {
        type: GET_SNOW_SKI.base,
        payload: getSnowSkiAction(baseUrl, authId, secret, latitude, longitude, units, rangeKm, maxResults, refresh)
    };
}

async function getSnowSkiAction(baseUrl, authId, secret, latitude, longitude, units, rangeKm, maxResults, refresh) {
    const op = new SnowSkiProvider(baseUrl, authId, secret);
    return await op.getSnowSki(latitude, longitude, units, rangeKm, maxResults, refresh);
}
